export const userKeys = {
	userInformation: () => ["user-information"],
};

export const authKeys = {
	refreshAccessToken: () => ["auth", "refresh-access-token"] as const,
};
